import { useRouter } from 'next/router'

const GSAT_2025_SECOND_PATH = '/prediction/gsat2025-2'

/**
 * @description 현재 라우터의 경로가 GSAT 2025 하반기 페이지('/prediction/gsat2025-2')와
 * 일치하는지 확인합니다.
 */

export const useIsGsat2025SecondRoute = () => {
  const router = useRouter()
  return router.pathname === GSAT_2025_SECOND_PATH
}
